export const REACT_APP_BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL;
export const REACT_APP_BACKEND_STORAGE_URL =
  process.env.REACT_APP_BACKEND_STORAGE_URL;
